import type { IPhoneNumber } from './types';

export function PhoneNumberFactory(extraProps?: Partial<IPhoneNumber>): IPhoneNumber {
  return {
    country: 'US',
    national_number: '9876543210',
    ...extraProps,
  } as IPhoneNumber;
}
